import { SubModule } from "../../types/SubModule";
import {
  SubModuleAction,
  SubModuleActionType,
} from "../actions/subModuleAction";

const initialState: SubModule[] = [];

export const subModuleReducer = (
  state = initialState,
  action: SubModuleAction,
): SubModule[] => {
  switch (action.type) {
    case SubModuleActionType.FETCH_SUB_MODULES:
      return action.data;
    case SubModuleActionType.FETCH_SUB_MODULES_PROJECTID:
      return action.data;
    case SubModuleActionType.ADD_SUB_MODULE:
      return [...state, action.data];
    case SubModuleActionType.EDIT_SUB_MODULE:
      return state.map((sm) => (sm.id === action.data.id ? action.data : sm));
    case SubModuleActionType.DELETE_SUB_MODULE:
      return state.filter((sm) => sm.id !== action.data);
    default:
      return state;
  }
};
